// extracted by mini-css-extract-plugin
module.exports = {"main":"CategoryTreeMobile_main__wdRIi","wrap":"CategoryTreeMobile_wrap__jxxAb","point":"CategoryTreeMobile_point__hEE1r","load":"CategoryTreeMobile_load__7t7YG"};